<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Manutenções"
          buttonText="Agendar manutenção"
          :buttonFunction="newMaintenance"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="searchPlate"
                  :items="vehicles"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  placeholder="Placa do veículo"
                  prepend-icon="mdi-car"
                />
              </v-col>
            </v-flex>
            <v-flex xs12 md5 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="searchClient"
                  :items="clients"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  placeholder="Cliente"
                  prepend-icon="mdi-office-building"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="center">
                <v-btn
                  block
                  class="mt-4 white--text"
                  color="primary"
                  @click="filter"
                >
                  Pesquisar
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-flex class="mx-3 my-2" xs12 md12>
          <v-row justify="start">
            <v-col align="start">
              <v-tabs>
                <v-tab
                  @click="
                    () => {
                      situation = true;
                      loadData();
                    }
                  "
                >
                  Ativas
                </v-tab>
                <v-tab
                  @click="
                    () => {
                      situation = false;
                      loadData();
                    }
                  "
                >
                  Encerradas
                </v-tab>
                <v-tab
                  @click="
                    () => {
                      situation = 'all';
                      loadData();
                    }
                  "
                >
                  Todas
                </v-tab>
              </v-tabs>

              <v-data-table
                :headers="headers"
                :items="maintenanceData"
                item-key="name"
                group-key="category"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                class="elevation-1 mt-2"
                :footer-props="{
                  'items-per-page-text': 'Linhas por página:',
                }"
                no-data-text="Nenhuma manutenção cadastrada"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.client.name }}</td>
                    <td>{{ item.begin_date | formatDate() }}</td>
                    <td>{{ item.end_date | formatDate() }}</td>
                    <td>{{ item.vehicle.plate }}</td>
                    <td>{{ item.active | formatBoolean() }}</td>
                    <td>
                      {{ item.user ? item.user.name : 'Desconhecido(a)' }}
                    </td>
                    <td>
                      <ActionButton
                        v-if="situation == true"
                        message="Finalizar manutenção"
                        icon="done"
                        color="success"
                        @onclick="changeMaintenance(item, 'finish')"
                      />
                      <!-- <ActionButton
                        v-if="situation == true"
                        message="Editar manutenção"
                        icon="edit"
                        @onclick="editItem(item)"
                      /> 
                      <ActionButton
                        v-if="situation == true"
                        message="Excluir manutenção"
                        icon="delete"
                        color="error"
                        @onclick="changeMaintenance(item, 'delete')"
                      /> -->
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-layout justify="center">
      <v-dialog v-model="maintenance_type_modal" persistent max-width="400px">
        <v-card>
          <v-card-title>
            <span class="headline">{{
              this.maintenance.id ? 'Editar manutenção' : 'Nova manutenção'
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <label class="subheading font-weight-medium">Veículo:</label>
                  <v-autocomplete
                    style="height: 50px;"
                    outlined
                    v-model="maintenance.vehicle_id"
                    :items="vehicles"
                    color="blue darken-4"
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>
                </v-flex>
                <hr />
                <v-flex xs12 sm12 md12>
                  <span class="subheading font-weight-medium">
                    Data e hora de
                    <span class="checkin-text">Inicio</span>
                  </span>
                  <div style="margin: 10px 0px 15px 0px;" class="form-control">
                    <datetime
                      input-id="inputDate"
                      type="datetime"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      :min-datetime="dateNow()"
                      :minute-step="getConfigMinuteStep()"
                      v-model="maintenance.begin_date"
                    ></datetime>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <span class="subheading font-weight-medium">
                    Data e hora de
                    <span class="checkin-text">Fim</span>
                  </span>
                  <div style="margin: 10px 0px 15px 0px;" class="form-control">
                    <datetime
                      input-id="inputDate"
                      type="datetime"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      :min-datetime="dateNow()"
                      :minute-step="getConfigMinuteStep()"
                      v-model="maintenance.end_date"
                    ></datetime>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="maintenance_type_modal = false"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="formMaintenance()"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <modalPadrao
        :showModal="modalConfirmacao.open"
        :ifTitle="true"
        :Title="modalConfirmacao.title"
        :ifTwoBtn="true"
        :TextFirstBtn="'Não'"
        :TextSecondBtn="'Sim'"
        @btnUm="modalConfirmacao.open = false"
        @btnDois="actionModalConfirmacao"
      ></modalPadrao>
    </v-layout>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import { Datetime } from 'vue-datetime';
import MaintenanceController from '../../controllers/MaintenanceController';
import ConfigurationController from '../../controllers/ConfigurationController';
import VehicleController from '../../controllers/VehicleController';
import ClientController from '../../controllers/ClientController';
import moment from 'moment';
import Constants from '../../models/constants/Constants';
import ActionButton from '../shared/ActionButtonsTemplate';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';
import modalPadrao from '../shared/ModalPadrao.vue';

export default {
  components: {
    Datetime,
    ActionButton,
    TitleWithButton,
    modalPadrao,
  },
  data() {
    return {
      maintenanceController: new MaintenanceController(this.$resource),
      configurationController: new ConfigurationController(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      clientController: new ClientController(this.$resource),
      clienteId: localStorage.getItem('client_id'),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      maintenanceData: [],
      clients: [],
      vehicles: [],
      situation: true,
      searchPlate: null, //id do veículo
      searchClient: null, //id do condomínio
      maintenance: {},
      sortBy: 'begin_date',
      sortDesc: true,
      headers: [
        { text: 'Condomínio', value: 'client.name' },
        { text: 'Data de início', value: 'begin_date' },
        { text: 'Data final', value: 'end_date' },
        { text: 'Placa', value: 'vehicle.plate' },
        { text: 'Ativo', value: 'active' },
        { text: 'Autor(a)', value: 'user.name' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      maintenance_type_modal: false,
      modalConfirmacao: {
        open: false,
        title: '',
        action: '',
      },
      configurations: {
        price_hour: {
          value: null,
        },
        payment: {
          value: null,
        },
        longitude_visualization: {
          value: null,
        },
        latitude_visualization: {
          value: null,
        },
        request_end_wait_timespan_in_minutes: {
          value: null,
        },
      },
    };
  },
  created() {
    this.getConfigurations();
    this.loadData();
    this.getClients();
    this.getVehicles();
  },
  methods: {
    changeMaintenance(item, action) {
      this.actionItem = item;
      this.action = action;

      switch (this.action) {
        case 'finish':
          this.modalConfirmacao.title = 'Deseja finalizar a manutenção?';
          break;
        case 'delete':
          this.modalConfirmacao.title =
            'Deseja excluir o registro de manutenção?';
          break;
      }
      this.modalConfirmacao.action = action;
      this.modalConfirmacao.open = true;
    },
    async actionModalConfirmacao() {
      switch (this.action) {
        case 'finish':
          return this.finishMaintenance();
        case 'delete':
          return this.deleteMaintenance();
      }
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    getConfigMinuteStep() {
      let valueNotEmpty = !(
        this.configurations.request_end_wait_timespan_in_minutes.value === ''
      );
      if (
        this.configurations.request_end_wait_timespan_in_minutes.value ||
        valueNotEmpty
      ) {
        return Number(
          this.configurations.request_end_wait_timespan_in_minutes.value
        );
      }
      return Number(Constants.CONFIG_MINUTE_STEP_DATE_TIME_DEFAULT);
    },
    async getConfigurations() {
      let configs = await this.configurationController.getAll(this.clienteId);
      this.configurations = configs;
    },
    async formMaintenance() {
      let selectedVehicle = this.vehicles.filter(
        item => this.maintenance.vehicle_id == item.id
      );
      this.maintenance.client_id = selectedVehicle[0].client_id;

      if (this.maintenance.id) {
        this.updateMaintenance();
        return;
      }
      this.createMaintenance();
    },
    async loadData({ withFilters = false } = {}) {
      this.maintenanceData = [];
      this.blockScreen = true;

      this.maintenanceController
        .getAllMaintenance({
          clientId: withFilters ? this.searchClient : null,
          vehicleId: withFilters ? this.searchPlate : null,
          situation: this.situation,
        })
        .then(
          response => {
            if (response.body.length > 0) {
              this.maintenanceData = response.body;
            }
          },
          err => console.log(err)
        );

      this.blockScreen = false;
    },
    filter() {
      this.loadData({
        withFilters: true,
      });

      this.searchPlate = null;
      this.searchClient = null;
    },
    async getVehicles() {
      await this.vehicleController.getAllVehicles().then(
        vehicles => {
          vehicles.forEach(element => {
            this.vehicles.push({
              id: element.id,
              value: { id: element.id, valor: element.vehicle_model.model },
              text: element.vehicle_model.model,
              name: `${element.vehicle_model.model} - ${element.plate}`,
              client_id: element.client.id,
            });
          });
        },
        err => console.log(err)
      );
    },
    async getClients() {
      await this.clientController.getAllClients().then(
        clients => {
          clients.forEach(element => {
            this.clients.push({
              id: element.id,
              name: element.name,
            });
          });
        },
        err => console.log(err)
      );
    },
    newMaintenance() {
      //Limpa formulário
      this.maintenance = {};
      this.maintenance_type_modal = true;
    },
    editItem(item) {
      this.maintenance.id = item.id;
      this.maintenance.vehicle = item.vehicle;
      this.maintenance.vehicle_id = item.vehicle_id;
      this.maintenance.begin_date = moment(item.begin_date).toISOString(true);
      this.maintenance.end_date = moment(item.end_date).toISOString(true);

      this.maintenance_type_modal = true;
    },
    async createMaintenance() {
      try {
        let response = await this.maintenanceController.createMaintenance(
          this.maintenance
        );
        this.maintenance_type_modal = false;
        this.loadData();
        if (response.body.message)
          return this.$awn.alert(response.body.message);
        return this.$awn.success('Manutenção criada com sucesso');
      } catch (err) {
        this.$awn.alert(err.body);
      }
    },
    async updateMaintenance() {
      try {
        let response = await this.maintenanceController.updateMaintenance(
          this.maintenance
        );
        this.maintenance_type_modal = false;
        this.loadData();
        if (response.body.message)
          return this.$awn.alert(response.body.message);
        return this.$awn.success('Manutenção alterada com sucesso');
      } catch (err) {
        this.$awn.alert(err.body);
      }
    },
    async finishMaintenance() {
      try {
        await this.maintenanceController.finishMaintenance(this.actionItem.id);
        this.loadData();
        this.modalConfirmacao.open = false;
        return this.$awn.success('Manutenção finalizada com sucesso');
      } catch (err) {
        this.$awn.alert('Falha ao encerrar manutenção');
        console.log(err);
      }
    },
    async deleteMaintenance() {
      try {
        await this.maintenanceController.deleteMaintenanceById(
          this.actionItem.id
        );
        this.loadData();
        this.modalConfirmacao.open = false;
        return this.$awn.success('Manutenção excluída com sucesso');
      } catch (err) {
        this.$awn.alert('Falha ao excluir manutenção');
        console.log(err);
      }
    },
  },
  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY HH:mm');
      }
      return 'Sem data';
    },
    formatBoolean(value) {
      return value ? 'SIM' : 'NÃO';
    },
  },
};
</script>

<style scoped>
.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}
.colorSelectedBack {
  background-color: var(--secondary-color);
}
.sizeTop {
  height: 48px;
}

hr {
  width: 2px;
  height: 25px;
  margin: auto 0;
}

.button {
  margin: 0 auto;
}

.button-text {
  text-transform: none;
}

.second {
  margin-bottom: 46px;
}

.sizePart {
  width: 49%;
  text-align: center;
}

.cardBottom {
  position: absolute;
  bottom: 56px;
  border-radius: 0;
}

.cardRadius {
  border-radius: 4px;
}

.carSelected {
  border: 2px solid var(--secondary-color) !important;
}

.cardTitle {
  font-size: 18px;
}

.cardContent {
  display: flex;
  justify-content: space-between;
}

.creditCard {
  display: inline-flex;
}

.coupon {
  display: flex;
}

.couponBtn {
  outline: none;
}

.vehicle {
  display: flex;
}

.modelo {
  font-size: 16px;
  color: #181f4d;
}

.caption {
  color: #181f4d;
}

.contentLeft {
  display: inline-block;
  width: 60%;
}

.contentRight {
  display: inline-block;
  width: 40%;
}

.vehicleImg {
  margin-left: -10px;
}
.autocomplete__inputs input {
  height: 44px !important;
}
.vdatetime {
  width: 100%;
}

.inputs {
  border: 1px solid rgb(173, 173, 173);
  border-radius: 6px;
  align-content: middle;
  width: 90%;
  margin: 0 auto;
  display: flex;
}

.border {
  border: 2px solid grey;
}

.borderBottom {
  border-bottom: 1px solid gray;
}

.bottom {
  margin-bottom: 60px;
}

.fab {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 0;
  display: flex;
}

.floatBtn {
  position: absolute;
  bottom: 56px;
  width: 100%;
  margin: 0 auto;
}

.colorBtn {
  background-color: var(--primary-color) !important;
}

.checkin {
  background-color: var(--secondary-color);
}

.checkin-text {
  color: var(--secondary-color);
}

.checkinBorder {
  border: 1px solid var(--secondary-color) !important;
}

.checkout {
  background-color: var(--orange-color) !important;
}

.checkout-text {
  color: var(--orange-color);
}

.checkoutBorder {
  border: 1px solid var(--orange-color) !important;
}

.total {
  color: #181f4d;
}
</style>
